module.exports = __webpack_public_path__ + "img/06_full.8738c0eb.jpg";